import { proxy } from 'valtio';

type SidebarNavState = {
    isOpen: boolean;
};

const sidebarNavStateDefaults: SidebarNavState = {
    isOpen: false,
};

const sidebarNavState = proxy<SidebarNavState>(sidebarNavStateDefaults);

export { sidebarNavState, sidebarNavStateDefaults };
